import __request__ from "routing/request";
export function opensearchVersions(requestOptions) {
  return __request__("GET", "/datanodes/upgrade/indexer/overview", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function startReplication(requestOptions) {
  return __request__("POST", "/datanodes/upgrade/replication/start", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function stopReplication(requestOptions) {
  return __request__("POST", "/datanodes/upgrade/replication/stop", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function status(requestOptions) {
  return __request__("GET", "/datanodes/upgrade/status", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
